import { render, staticRenderFns } from "./MobileSplash.vue?vue&type=template&id=630bbd85&scoped=true"
import script from "./MobileSplash.vue?vue&type=script&lang=js"
export * from "./MobileSplash.vue?vue&type=script&lang=js"
import style0 from "./MobileSplash.vue?vue&type=style&index=0&id=630bbd85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630bbd85",
  null
  
)

export default component.exports